export const HEADER_LEFT_CONTAINER_WIDTH = 800;
export const STATUS_LOZENGE_WIDTH = 96;

export const SIDEBAR_RESIZE_BUTTON_SELECTOR = 'VersionDetailsRightSidebarResizeButton';
